import { ChevronLeft } from "lucide-react";
import CardPlanoEmpresarial from "../components/Cards/CardPlanoEmpresarial";
import CardPlanoResidencial from "../components/Cards/CardPlanoResidencial";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useNavigate } from "react-router-dom";
import CardClientesAtivos from "../components/Cards/CardClientesAtivos";
import CardClientesDesativos from "../components/Cards/CardClientesDesativos";
import { motion } from "framer-motion";
import { useContext } from "react";
import { AuthContext } from "../Contexts/AuthContext";
import { normalizeAdminPermissions } from "../utils/adminPermissions";

export default function EstadoClientes() {
  const navigate = useNavigate();
  const { usuario } = useContext(AuthContext);
  const permissoes = normalizeAdminPermissions(usuario);
  const superAdmin = usuario?.tipoUsuario === "super";
  const podeVerAtivos = superAdmin || permissoes.verClientesAtivos;
  const podeVerDesativos = superAdmin || permissoes.verClientesDesativos;

  const propsCardClientesAtivos = {
    descricao: "Clientes Ativos",
  };

  const propsCardClientesDesativos = {
    descricao: "Clientes Desativos",
  };

  return (
    <div className="flex h-screen justify-between flex-col font-questrial text-white">
      {/* Navbar */}
      <div className="bg-blue-500 h-[34%] z-10 sticky top-0">
        <NavBar />
      </div>

      {/* Conteúdo animado */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="z-0 lg:z-20 lg:h-[50px] lg:w-[600px] md:w-[500px] sm:w-[440px]
        lg:-mt-[100px] flex flex-col sm:items-center mb-4 sm:flex-row
        justify-around items-center space-y-4 sm:space-y-0 sm:space-x-4
        container mx-auto mt-8"
      >
        {/* Botão voltar */}
        <motion.button
          whileHover={{ x: -5 }}
          whileTap={{ scale: 0.95 }}
          className="group flex absolute left-4 bottom-[76%]"
          onClick={() => navigate(-1)}
        >
          <div className="flex md:flex lg:hidden">
            <ChevronLeft className="text-black" />
            <span className="text-sm ml-1 text-black">Voltar</span>
          </div>
        </motion.button>

        {podeVerAtivos && (
          <motion.button
            onClick={() => navigate("ativos")}
            className="w-[60%] sm:w-[48%] lg:w-[43%]"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.1 }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <CardClientesAtivos {...propsCardClientesAtivos} />
          </motion.button>
        )}

        {podeVerDesativos && (
          <motion.button
            onClick={() => navigate("desativos")}
            className="w-[60%] sm:w-[48%] lg:w-[43%]"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <CardClientesDesativos {...propsCardClientesDesativos} />
          </motion.button>
        )}
      </motion.div>

      {/* Footer */}
      <div className="bg-blue-500 p-4 pb-2 font-extralight">
        <Footer />
      </div>
    </div>
  );
}
